import { render, staticRenderFns } from "./VoteExamples.vue?vue&type=template&id=43c65732&"
import script from "./VoteExamples.vue?vue&type=script&lang=js&"
export * from "./VoteExamples.vue?vue&type=script&lang=js&"
import style0 from "./VoteExamples.vue?vue&type=style&index=0&id=43c65732&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports